/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'arrow': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: `<defs><clipPath id="svgicon_arrow_b"><path pid="0" _fill="none" d="M0 0h13v25H0z"/></clipPath><clipPath id="svgicon_arrow_a"><path pid="1" d="M0 0h25v25H0z"/></clipPath></defs><g clip-path="url(#svgicon_arrow_a)"><g transform="rotate(180 9.5 12.5)" clip-path="url(#svgicon_arrow_b)"><path pid="2" d="M.42.42l11.739 12.079L.42 24.579" _fill="none" _stroke="currentColor" stroke-width="1.45"/></g></g>`
  }
})
/* tslint:enable */
